interface GameMode {
    symbol: string;
    name: string;
    startingLevel: number;
    endingLevel: number;
}
    
const gameModes: GameMode[] = [
    {
        symbol: "X",
        name: "Extreme",
        startingLevel: 300,
        endingLevel: 399
    },
    {
        symbol: "H",
        name: "Hard",
        startingLevel: 200,
        endingLevel: 299
    },    
    {
        symbol: "M",
        name: "Medium",
        startingLevel: 100,
        endingLevel: 199
    },
    {
        symbol: "E",
        name: "Easy",
        startingLevel: 0,
        endingLevel: 99
    }
];

export const GetGameMode = (level: number): GameMode =>
    gameModes
        .find(mode => 
            mode.startingLevel <= level
            && level <= mode.endingLevel
        )!;
        
export const GetMaxLevelForMode = (level: number): number => {
    const gameMode = GetGameMode(level);
    return gameMode.endingLevel + 1;
}

